module.exports = __webpack_public_path__ + "static/media/src_image_vip_icon_loufeng.9d612f65.png";